import { render, staticRenderFns } from "./SelectionField.vue?vue&type=template&id=655899d3"
import script from "./SelectionField.vue?vue&type=script&lang=js"
export * from "./SelectionField.vue?vue&type=script&lang=js"
import style0 from "./SelectionField.vue?vue&type=style&index=0&id=655899d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../gim-wms/gim-wms-backend-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports